<template>
  <div class="wait-auth">
    <nd-pulldown class="wait-page" :refresh="refresh">
      <navigation :showBack="false">
        <template v-slot:right>
          <div class="home-button" @click="showBackHomePopup">返回首页</div>
        </template>
      </navigation>
      <div class="wait-main">
        <div class="wait-content">
          <div class="wait-image"></div>
          <div class="wait-title">额度审批中,您前面还有 <span>{{ queueInfo.curPosNum }}</span> 人排队</div>
          <div class="wait-info" v-if="isKingWait">
            尊敬的会员，已为您启用<span>VIP专属审核</span>通道
          </div>
          <div class="wait-info" v-else>
            使用快速通道特权，提升至第<span>{{queueInfo.upToPosNum}}</span>名，快至<span>5S</span>出结果
          </div>
          <div class="wait-progress">
            <audit-progress
              :progress="queueInfo.percent"
              :queueProcess="queueInfo.queueProcess"
            ></audit-progress>
          </div>
        </div>
        <img v-if="isKingWait" src="./images/img_wait_king.png" class="king-wait">
        <div v-else class="wait-btns">
          <div class="btn-buy" :class="{disableBuy}" v-stat="{ id: 20297 }" @click="jumpBuy">
            激活特权免排队
          </div>
          <p class="popup-foot-content">开通即同意<span @click="routerToVipProtocol(supplier)" class="blue">《会员用户协议》</span></p>
        </div>
      </div>
      <div class="title-container">
        <span class="dir"></span>
        <span class="title">特权卡超值权益</span>
        <a @click="detail">查看详情 ></a>
      </div>
      <div class="wait-welfare" v-if="supplier === 'OAK'">
        <div class="welfare-item">
          <img src="./images/icon_tisu.png" class="item-icon" />
          <div class="item-info">
            <div class="info-title">授信审核提速</div>
            <div class="info-text">优先审核<br />最快5秒出审核结果</div>
          </div>
        </div>
        <div class="welfare-item">
          <img src="./images/icon_eleme.png" class="item-icon" />
          <div class="item-info">
            <div class="info-title">饿了么超级会员</div>
            <div class="info-text">5折优惠</div>
          </div>
        </div>

        <div class="welfare-item">
          <img src="./images/icon_huafei.png" class="item-icon" />
          <div class="item-info">
            <div class="info-title">话费充值抵扣券</div>
            <div class="info-text">满30元减3元</div>
          </div>
        </div>

        <div class="welfare-item">
          <img src="./images/icon_ruixing.png" class="item-icon" />
          <div class="item-info">
            <div class="info-title">瑞幸咖啡26元券</div>
            <div class="info-text">5折优惠</div>
          </div>
        </div>
      </div>
      <!-- 橡树 -->
      <div class="wait-welfare" v-if="supplier === 'JI_WEI'">
        <div class="welfare-item">
          <img src="./images/icon_tisu.png" class="item-icon" />
          <div class="item-info">
            <div class="info-title">授信审核提速</div>
            <div class="info-text">优先审核<br />最快5秒出审核结果</div>
          </div>
        </div>
        <div class="welfare-item">
          <img src="./images/icon_shipin.png" class="item-icon" />
          <div class="item-info">
            <div class="info-title">5折视频会员</div>
            <div class="info-text">爱奇艺/腾讯/芒果 <br>优酷</div>
          </div>
        </div>

        <div class="welfare-item">
          <img src="./images/icon_yinyue.png" class="item-icon" />
          <div class="item-info">
            <div class="info-title">5折影音会员</div>
            <div class="info-text">网易云/酷我音乐<br>QQ音乐</div>
          </div>
        </div>

        <div class="welfare-item">
          <img src="./images/icon_shenghuo.png" class="item-icon" />
          <div class="item-info">
            <div class="info-title">超值生活服务</div>
            <div class="info-text">0元领5元美团券</div>
          </div>
        </div>
      </div>

    </nd-pulldown>
    <nd-dialog v-model="dialog4" closeBtn :footer="false">
      <div class="service-dialog3">
        <div class="description">
          您当前如需使用权益功能，请更新至最新版本。
          您可前往「天美贷-我的」点击「版本更新」进行升级。
        </div>
        <div class="flex">
          <nd-button class="btn small" @click="jumpHome">立即升级</nd-button>
        </div>
      </div>
    </nd-dialog>
    <nd-dialog
      v-model="backPopupVisible"
      :closeBtn="true"
      :footer="false"
    >
      <back-pop :progress="queueInfo.percent"
                @jumpHomeAction="jumpHome"
                @jumpBuy="jumpBuy"
                @toProtocol="routerToVipProtocol(supplier)"
      />
    </nd-dialog>
  </div>
</template>

<script>
import VueLottie from 'vue-lottie'
import waitData from '@/assets/json/wait.json'
import AuditProgress from './components/audit-progress.vue'
import { mapActions } from 'vuex'
import { getKey, judgeClientSystem } from '@/assets/utils'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import { Base64 } from 'js-base64'
import { generateUUID } from '@/services/stat'
import backPop from './components/back-home-pop.vue'
const deviceInfo = {
  terminal: getKey('terminal') || 'H5',
  appVersion: getKey('appVersion'),
  uuid: generateUUID()
}


export default {
  components: {
    VueLottie,
    AuditProgress,
    backPop
  },
  computed: {
    isKingWait () {
      return this.queueInfo.queueProcess === 'KING_QUEUE'
    }
  },
  data () {
    return { // 底部小美vip广告位显示
      applyNo: this.$route.query.applyNo,
      lottieOptions: {
        animationData: waitData
      },
      disableBuy: true,
      dialog4: false,
      progress: 30,
      goodsInfo: {},
      queueInfo: {
        remainMin: 30,
        curPosNum: 999,
        upToPosNum: 1,
        percent: 30,
        queueProcess: '',
        kingWaitTime: 0
      },
      timer: null,
      supplier: 'JI_WEI',
      backPopupVisible: false
    }
  },
  async created () {
    await this.fillProcess()
    if (this.$route.query.sign) {
      setTimeout(() => {
        this.disableBuy = false
      }, 7000)
    } else {
      this.disableBuy = false
    }
    this.queryQueueInfo()
    this.getSupplier()
    this.$report({
      id: 20998
    })
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  methods: {
    ...mapActions('authentication', ['queryQueueX', 'goodsInfoX', 'fillProcessX']),
    ...mapActions('user', ['showStatusX']),
    // 校验用户是否是需要去补充资料银行卡的人群
    async fillProcess () {
      return new Promise(async (resolve, reject) => {
        const { success, data } = await this.fillProcessX()
        if (success) {
          if (data.process === 'NON') {
            resolve()
          } else {
            this.$router.replace(`/authentication/pre-base`)
          }
        }
      })
    },
    async getSupplier () {
      const { success, data } = await this.goodsInfoX({
        goodsCd: 'FAC_M',
        productCode: 'TMD',
        memberGoodsGroupCd: 'PRIVILEGE'
      })
      if (success && data && data.length) {
        this.supplier = data[0].supplier
        this.goodsInfo = data[0]
      }
    },
    detail () {
      if (this.isKingWait) {
        return this.jumpToKingCardPage()
      }
      const userInfo = getKey('userInfo')
      const channel = getKey('channel') || ''
      const url = `${process.env.VUE_APP_PAYURL}/privilege/credit/speed?token=${userInfo.token}&channel=${channel}&refurl=${window.location.origin}`
      window.location.href = url
    },
    // 下拉刷新
    refresh () {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.queryQueueInfo()
    },
    // 获取排队信息
    async queryQueueInfo () {
      const { success, data } = await this.queryQueueX()
      if (success) {
        if (!data.creditQueue) {
          return this.$router.replace(
            `/authentication/result?applyNo=${this.applyNo}`
          )
        }
        this.queueInfo = data
        if (this.isKingWait) {
          // 至尊王卡排队，延时后直接跳转
          this.timer = setTimeout(() => {
            this.queueInfo.percent = 90
            // 动画结束后直接跳转
            setTimeout(() => {
              return this.$router.replace(
                `/authentication/result?applyNo=${this.applyNo}`
              )
            }, 500)
          }, this.queueInfo.kingWaitTime * 1000)
        } else {
          // 普通排队，轮询接口
          this.timer = setTimeout(() => {
            this.queryQueueInfo()
          }, 3000)
        }
        return this.$bus.$emit('ready')
      }
      this.$bus.$emit('error')
    },
    // 跳转购买授信提速卡
    jumpBuy () {
      if (this.disableBuy) return
      const host = encodeURIComponent(window.location.href)
      const gid = localStorage.getItem('gid')
      const token = getKey('userInfo', 'token') || ''
      const channel = getKey('channel') || ''
      const device = Base64.encode(
        JSON.stringify(
          Object.assign({}, deviceInfo, {
            longitude: getKey('longitude') || '',
            latitude: getKey('latitude') || ''
          })
        )
      )


      const origin = process.env.VUE_APP_PAYURL
      const { discountPrice } = this.goodsInfo || {}
      window.location.href = `${origin}/pay?memberType=FAC_M&memberGoodsGroupCd=PRIVILEGE&discountPrice=${discountPrice}&host=${host}&gid=${gid}&token=${token}&device=${device}&channel=${channel}&refurl=${window.location.origin}`
    },
    showBackHomePopup () {
      this.$sensors.track('PopupDisplay', { msg_name: 'FAC_M' })
      if (this.isKingWait) {
        this.jumpHome()
        return
      }
      this.backPopupVisible = true
    },
    jumpHome () {
      if (hasNativeMethod('navigateTo') && judgeClientSystem() !== 'IOS') {
        return jsBridge('exit')
      } else {
        this.$router.replace('/')
      }
    },
    // 跳转权益卡vip界面
    jumpVip () {
      if (
        hasNativeMethod('getUserInfo') &&
        judgeClientSystem() === 'Android' &&
        getKey('appVersion') &&
        getKey('appVersion') < '1.7.4'
      ) {
        this.dialog4 = true
      } else {
        this.$router.push('/vip/index')
      }
    },
    // 跳转协议页面
    routerToVipProtocol (supplier) {
      this.visible = false
      if (supplier === 'JI_WEI') {
        this.$router.push('/protocol/vip-jw')
      } else if (supplier === 'WH') {
        this.$router.push('/protocol/vip-wh')
      } else {
        this.$router.push('/protocol/vip')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.wait-auth {
  .home-button {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 40px;
    margin-right: 30px;
    text-decoration:underline;
  }
  .title-container {
    display: flex;
    justify-content: space-between;
    padding: 0 47px;
    align-items: center;
    margin-top: 60px;
    .dir {
      width: 8px;
      height: 40px;
      background: #f69d61;
    }
    .title {
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      flex: 1;
      padding-left: 15px;
    }

    a {
      font-size: 28px;
      color: #999999;
    }
  }
  height: 100%;
  .wait-page {
    background-color: #fff;
    .wait-main {
      background-color: #F5F9FF;
      padding: 80px 44px;
      border-radius: 20px;
      margin: 0px 30px;
      .wait-header {
        font-size: 32px;
        color: #ff3833;
        text-decoration: underline;
        text-align: right;
        margin-right: 60px;
      }
      .wait-image {
        width:450px;
        height:205px;
        background: url(./images/img_wait.png) no-repeat;
        background-size: 100% 100%;
      }
      .wait-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        .wait-lottie {
          width: 210px !important;
          height: 210px !important;
        }
        .wait-title {
          font-size: 34px;
          color: #333333;
          margin-top: 29px;
          line-height: 48px;
          font-weight: bold;
          span {
            color: #FF4633;
          }
        }
        .wait-info {
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 37px;
          margin-top: 6px;
          span {
            color: #FF4633;
          }
        }
        .wait-progress {
          width: 600px;
          margin-top: 45px;
        }
      }
    }
    .wait-welfare {
      display: flex;
      justify-content: space-between;
      border-radius: 20px;
      background-color: #fffbf8;
      padding: 50px 30px;
      margin: 20px 30px;
      flex-wrap: wrap;
      height: 300px;
      & :nth-child(3), & :nth-child(4){
        margin-top: 40px;
      }
      .welfare-item {
        display: flex;
        height: 100px;
        width: 45%;
        .item-icon {
          width: 76px;
          height: 76px;
        }
        .item-info {
          margin-left: 9px;
          color: #666666;
          .info-title {
            font-size: 28px;
            line-height: 40px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            width: 120%;
          }
          .info-text {
            font-size: 20px;
            line-height: 28px;
            margin-top: 4px;
          }
        }
      }
    }
    .king-wait {
      width: 600px;
      height: 72px;
      margin-top: 84px;
    }
    .wait-btns {
      margin-top: 50px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .btn-buy {
        width: 440px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        background: linear-gradient(90deg, #ff3333 0%, #ff5f34 100%);
        border-radius: 40px;
        color: #fff;
        font-size: 36px;
        font-weight: bold;
        margin-top: 50px;
        animation: rotate 1s linear infinite;
        &.disableBuy{opacity: .3;}
      }
      .popup-foot-content {
        font-size: 24px;
        margin-top: 30px;
        span {
          color: #8EB2D8;
        }
      }
      @keyframes rotate {
        0% {
          transform: scale(1.1);
        }
        50% {
          transform: scale(1);
        }
        100% {
          transform: scale(1.1);
        }
      }
    }
    .wait-bottom {
      width: 670px;
      margin: 98px auto 0;
      .bottom-img {
        width: 100%;
      }
    }
    .wait-footer {
      width: 670px;
      margin: 48px auto 0;
      padding-bottom: 30px;
      img {
        width: 100%;
      }
    }
  }
}
.service-dialog3 {
  text-align: left;
  padding: 0 48px 38px;
  .description {
    margin-top: 31px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .thick {
    font-weight: 700 !important;
  }
  .btn {
    width: 300px;
    height: 80px;
    line-height: 80px;
    margin: 40px auto 0;
  }
  .grey {
    background: white;
    color: #333;
    border: 1px solid #333;
    margin: 20px auto 0 !important;
  }
}
</style>
